module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"guides":"HoneyMoney Guides"},"ru":{"guides":"Справка по ХаниМани","Close":"Закрыть"}}')
  delete Component.options._Ctor
}
